// extracted by mini-css-extract-plugin
export default {"body":"Technology_body__nutzr","mapWrap":"Technology_mapWrap__jEbcx"};